import "./ToggleSwitch.css";

const ToggleSwitch = ({
  checked = false,
  onChange,
  ariaLabel,
  disabled = false,
  className = "",
}) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={`toggle-switch${checked ? " is-on" : ""}${
        disabled ? " is-disabled" : ""
      } ${className}`.trim()}
      onClick={(event) => {
        event.stopPropagation();
        if (disabled) return;
        onChange?.(!checked);
      }}
    >
      <span className="toggle-switch-thumb" aria-hidden="true" />
    </button>
  );
};

export default ToggleSwitch;
